import declare from "dojo/_base/declare";
import AggregateController from "csi/heading/AggregateController";

export = declare(AggregateController, {
	postProcessSuccess() {
		this.inherited(arguments);
		this.widget.postActionRedrawNode(this);
		this.widget.getSiblingView("ValidationRules")?.refreshWidget();
	},
});
